import { CancelTokenSource } from 'axios'
import Agent from '../api/Agent'
import { IPaginationFilter } from '../models/Common'
import {
  CancelOrCloseRequest,
  EnquiryPreLodgementRequest,
  EnquiryTellUsMoreStepOneRequest,
  EnquiryTellUsMoreStepTwoRequest,
  EnquiryTellUsMoreSubmitRequest,
  IEnquiry,
  RequestInformationRequest,
} from '../models/Enquiry'
import { UpdateEnquiryAbnRequest } from '../models/ChnageABN'

class EnquiryDataService {
  getAll(filter: IPaginationFilter, source?: CancelTokenSource) {
    return Agent.Enquiries.getAll(filter, source)
  }

  createEnquiry = async (request: EnquiryPreLodgementRequest) => {
    return Agent.Enquiries.create(request)
  }

  getEnquiryDetails = async (id: string) => {
    return Agent.Enquiries.getEnquiryDetails(id)
  }

  cancelEnquiry = async (id: string) => {
    return Agent.Enquiries.cancelEnquiry(new CancelOrCloseRequest(id))
  }

  closeEnquiry = async (id: string) => {
    return Agent.Enquiries.closeEnquiry(new CancelOrCloseRequest(id))
  }

  submit = async (step: number, payload: IEnquiry) => {
    switch (step) {
      case 1:
        return Agent.Enquiries.saveStepOne(
          new EnquiryTellUsMoreStepOneRequest(payload)
        )
      case 2:
        return Agent.Enquiries.saveStepTwo(
          new EnquiryTellUsMoreStepTwoRequest(payload)
        )
      case 3:
        return Agent.Enquiries.submit(
          new EnquiryTellUsMoreSubmitRequest(payload)
        )
    }

    return Promise.reject('Invalid step')
  }

  getUpdateEnquiryViewModel = async (step: number, id: string) => {
    switch (step) {
      case 1:
        return Agent.Enquiries.getUpdateEnquiryStep1ViewModel(id)
      case 2:
        return Agent.Enquiries.getUpdateEnquiryStep2ViewModel(id)
    }

    return Promise.reject('Invalid step')
  }

  updateRequestInformationRequest = async (
    request: RequestInformationRequest
  ) => {
    return Agent.Enquiries.updateRequestInformation(request)
  }

  changeABN = async (abnToChange: UpdateEnquiryAbnRequest) => {
    return Agent.Enquiries.changeABN(abnToChange)
  }
}

export default new EnquiryDataService()
